module.exports = __webpack_public_path__ + "img/about-hero-pattern.5021c0f0.png";